import { render, staticRenderFns } from "./EmailSecondaryIcon.vue?vue&type=template&id=14071416"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14071416')) {
      api.createRecord('14071416', component.options)
    } else {
      api.reload('14071416', component.options)
    }
    module.hot.accept("./EmailSecondaryIcon.vue?vue&type=template&id=14071416", function () {
      api.rerender('14071416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/EmailSecondaryIcon.vue"
export default component.exports